(function(w, d) {
    function domReadyFunctions() {
        //PDF expandable text
        const trigger = document.querySelector('[data-target]');
        if (!trigger) return;
        
        const targetSelector = trigger.getAttribute('data-target');
        const target = document.querySelector(targetSelector);
        if (!target) return;
        
        // Ensure initial collapsed state
        target.classList.add('d-none');
        
        trigger.addEventListener('click', function () {
        const isVisible = target.classList.contains('d-block');
        
        if (isVisible) {
            target.classList.add('d-none');
            target.classList.remove('d-block');
            trigger.querySelector('blox-icon').icon='caret-down';
        } else {
            target.classList.add('d-block');
            target.classList.remove('d-none');
            trigger.querySelector('blox-icon').icon='caret-up';
        }
        });
    }

    if (d.readyState == 'loading') {
        d.addEventListener('DOMContentLoaded', function() {
            domReadyFunctions();
        });
    } else {
        domReadyFunctions();
    }
})(window, document);